var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"unavailable-ingredients-modal","scrollable":true,"max-width":1000,"width":"35%","height":"auto"},on:{"before-close":_vm.beforeClose}},[_c('error-modal-template',{attrs:{"error-message":_vm.message},on:{"button-clicked":function($event){return _vm.$modal.hide('unavailable-ingredients-modal');}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }